<template>
  <div>
    <search-bar @search="doSearch" @clear="doClear" :full-width="true" :query="mode.search.q" :doing="mode.search.doing"></search-bar>
    <panel title="Apartments" :footerShow="true">
      <div slot="headingElements">
        <div class="pull-right" v-if="selectedItems.length && _can('createSale')">
          <a @click.prevent="$refs.listBlock.flushSelection()" class="btn btn-default btn-flat">Cancel</a>
          <a @click.prevent="makeOffer" class="btn bg-success btn-flat">Make offer ({{selectedItems.length}})</a>
        </div>
      </div>
      <div class="row">
        <div :class="{'col-sm-10': selectedItems.length, 'col-sm-12': selectedItems.length === 0}">
          <apartment-list
            ref="listBlock"
            :items="items"
            :columns="{editableStatus: false, status: true, selection: _can('createSale'), deleteItem: _can('updateProject'), typeTitle: true}"
            :strictSelect="true"
            :showProject="true"
            :forceShowFloatingPrices="false"
            @itemDelete="deleteItem"
            @viewApartmentClick="viewApartmentClick"
            @toggleSort="toggleSort"
            @setApartmentItemStatus="setApartmentItemStatus"
            @selectionChanged="selectionChanged"
          >
          </apartment-list>
        </div>
        <div v-if="selectedItems.length" class="col-sm-2 border-green-400" style="padding-top: 10px;">
          <div class="row text-center"><h5><strong>Price calculation</strong></h5></div>
          <div class="row">
            <table class="table table-borderless table-columned">
              <tr>
                <td colspan="2">
                  <h6>Apartments</h6>
                </td>
              </tr>
              <tr v-for="(item, idx) in getSelectedItems()" :key="idx">
                <td class="text-right">
                  <strong>{{item.data.code}}</strong>:
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(item.data.price) }} &euro;
                </td>
              </tr>
              <tr>
                <td colspan="2"><br /></td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Total Price:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selectedPrice()) }} &euro;
                </td>
              </tr>
              <tr>
                <td colspan="2"><hr class="hr-condensed"/></td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6>Buying Costs</h6>
                </td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Transfer Tax:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selected_transferTaxCalc()) }} &euro;
                </td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Notary Cost:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selected_notaryCostCalc()) }} &euro;
                </td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Rendimmo Coaching:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selected_coachingAndVatCalc()) }} &euro;
                </td>
              </tr>
              <tr>
                <td colspan="2"><hr class="hr-condensed"/></td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Total buying costs:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selected_totalBuyingCosts()) }} &euro;
                </td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>Total Price +<br /> Buying Costs:</strong>
                </td>
                <td class="text-right">
                  {{ $formatter.formatPrice(this.$refs.listBlock.selected_totalTotalPrice()) }} &euro;
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div slot="footerElements">
        <div class="col-sm-12">
          <pagination :page="paging.page" :itemsPerPage="paging.perPage" :maxVisiblePage="5" :totalItems="paging.total" @page-change="__pageChanged"/>
        </div>
      </div>
    </panel>
    <modal id="apartmentViewForm" :size="'lg'" v-show="viewApartmentMode && currentApartment">
      <div slot="header">
        <button type="button" class="close" @click.prevent="viewApartmentClose()">×</button>
        <h5 class="modal-title">Apartment #{{currentApartment.data.code}}</h5>
      </div>
      <div slot="body">
        <apartment-form ref="apartmentViewForm" :entity="currentApartment" :createMode="false" :hide-header="true" :project="currentApartment.project" @updated="apartmentUpdated" @enterEditMode="enterApartmentEditMode"></apartment-form>
      </div>
      <div slot="footer">
        <button type="button" @click.prevent="viewApartmentClose()" class="btn btn-default legitRipple">Cancel</button>
        <button type="submit" @click.prevent="saveApartment()" :disabled="errors.any()" class="btn btn-primary legitRipple" v-show="apartmentEditMode">Save changes</button>
      </div>
    </modal>
    <overlay v-if="showLoader" message="Please wait..." html="<i class='icon-spinner2 icon-2x spinner'></i>"></overlay>
  </div>
</template>

<script>

import Vue from 'vue'

import ApartmentService from '@/services/apartment.service'

import Modal from '@/components/Modal'
import ApartmentForm from '../apartment/Form'
import ApartmentList from '../apartment/_partial/List'

import listMixin from '@/helpers/mixins/_listMixin'
import SearchBar from '../_partial/search-bar'

export default {
  name: 'ApartmentIndex',
  components: {ApartmentForm, Modal, ApartmentList, SearchBar},
  mixins: [listMixin],

  data () {
    return {
      id: null,
      itemTemplate: {
        note: '',
        status: 1,
        created_by: 1,
        paymentStatus: -1,
        receiveStatus: -1,
        showModal: false
      },
      mode: {
        apartmentStatusMap: {},
        search: {
          filter: {
            'project.status': [1]
          }
        }
      },
      viewApartmentMode: false,
      apartmentEditMode: false,
      currentApartment: {data: {}},
      selectedItems: [],
      showAdditionalActions: false,
      apartmentStatuses: [],
      apartmentAvailableStatuses: [],
      service: ApartmentService
    }
  },

  beforeMount () {
    this.mode.apartmentStatusMap = {
      'label-danger': 3,
      'bg-orange-300': 2,
      'label-success': 1
    }
    this.apartmentStatuses = [
      '',
      'Available', // 1
      'Reserved', // 2
      'Sold' // 3
    ]
    for (let i = 1; i < this.apartmentStatuses.length; i++) {
      this.apartmentAvailableStatuses.push(this.apartmentStatuses[i])
    }
  },

  mounted () {
    for (let idx in this.items) {
      // bill
      this.items[idx].paymentStatus = 3
      if (parseFloat(this.items[idx].billedSum) === parseFloat(this.items[idx].paidSum)) {
        if (this.items[idx].paidSum) {
          this.items[idx].paymentStatus = parseFloat(this.items[idx].paidSum) < parseFloat(this.items[idx].billedSum) ? 7 : 6
        }
      }
      // receive
      this.items[idx].receiveStatus = 3
      console.log(this.items[idx])
    }
  },

  watch: {
    'selectedItems': function (next, prev) {
      if (Array.isArray(next)) {
        if (next.length) {
          this.showAdditionalActions = true
        }
      }
      this.showAdditionalActions = false
    }
  },

  methods: {
    selected_totalPrice () {
      return this.$refs.listBlock.selectedPrice()
    },

    getSelectedItems () {
      return this.$refs.listBlock.items.filter((a) => { return this.selectedItems.indexOf(a.id) > -1 })
    },

    selectionChanged (ids) {
      this.selectedItems = ids
    },

    makeOffer () {
      if (this.selectedItems.length) {
        this.$router.push({'name': 'sale.create', params: {apartments: this.selectedItems}})
      } else {
        this.$popup.warning('Select at least one apartment to make offer')
      }
    },

    reset (forceItemsReset = true) {
      this.id = null
      this.groupStatuses = Vue.config.statusGroups['po'] ? Vue.config.statusGroups['po'] : Vue.config.statusGroups['*']
      for (let i = 0; i < this.groupStatuses.length; i++) {
        this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
      }
    },

    editItem (id) {
      this.$router.push('apartment/details/' + id)
    },

    setApartmentItemStatus (item, status) {
      let $vm = this
      this.service.update(item, {'id': item, 'status': status}, result => {
        $vm.items.forEach((i, idx) => {
          if (item === parseInt(i.id)) {
            $vm.updateItemRow(i)
          }
        })
      }, () => {
        $vm.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    updateItemRow (i) {
      this.service.item(i.id, result => {
        i.data.code = result.data.code
        i.data.price = result.data.price
        i.data.rent_month = result.data.rent_month
        i.data.rent_year = result.data.rent_year
        i.data.area = result.data.area
        i.data.floor = result.data.floor
        i.status = result.status
        i.updated_at = result.updated_at
      })
    },

    apartmentUpdated (item) {
      this.viewApartmentClose()
      this.refresh()
    },

    viewApartmentClick (id) {
      let $vm = this
      if (typeof id === 'object') {
        $vm.currentApartment = id
        $vm.showLoader = false
        $vm.viewApartmentMode = true
      } else {
        $vm.showLoader = true
        this.service.item(id, result => {
          $vm.currentApartment = result
          delete $vm.currentApartment.created_at
          $vm.showLoader = false
          $vm.viewApartmentMode = true
        }, () => {
          $vm.showLoader = false
          $vm.$popup.error('Can\'t load Apartment #' + $vm.$formatter.formatID(id) + ' details')
        })
      }
    },

    viewApartmentClose () {
      this.$refs.apartmentViewForm.cancelEditMode()
      this.viewApartmentMode = false
      this.apartmentEditMode = false
      this.currentApartment = {data: {}}
    },

    enterApartmentEditMode () {
      this.apartmentEditMode = true
    },

    saveApartment () {
      this.$refs.apartmentViewForm.saveData()
    }

  }
}
</script>

<style scoped>

</style>
